import { IAvailabilityV3BookingsResponse } from 'api/bookings';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions } from '../../../../../data/store';
import { isAdmin } from '../../../../../entities/admin/selectors';
import { getBookingsByProperty } from '../../../../../entities/bookings/actions';
import { bookingSummariesForProperty } from '../../../../../entities/bookings/selectors';
import { getProperty } from '../../../../../entities/properties/selectors';
import { IThunkDispatch } from '../../../../../store/middleware';
import { IState } from '../../../../../store/reducer';
import { useDataLoad } from '../../../../../view/helpers/hooks';
import { PropertyBookingsList } from './PropertyBookingsList';

type EventStatus = 'booked' | 'cancelled' | 'failed';
type TimePeriod = 'past' | 'present' | 'future';
type SortDirection = 'ascending' | 'descending';

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getBookings: (id: string, params: any) => dispatch(getBookingsByProperty(id, params)),
	getPropertyData: (id: string) => dispatch(actions.property.getById(id)).catch((e: any) => e),
});

const mapStateToProps = (propertyId: string) => (state: IState) => {

	const property = getProperty(propertyId, state);
	const bookings = bookingSummariesForProperty(propertyId, state) as IAvailabilityV3BookingsResponse;
	const admin = isAdmin(state);

	return {
		property,
		propertyId,
		bookings,
		admin,
		loading: state.views.bookings.loadingBookings
	};
};

export const PropertyBookingList = () => {
	const params = useParams();
	const propertyId = params.id || '';

	const [state, setState] = React.useState({
		page_number: 1,
		page_size: 25,
		sort_direction: 'ascending' as SortDirection,
		time_period: ['present', 'future'] as TimePeriod[],
		event_status: ['booked'] as EventStatus[]
	});

	const props = {
		...useSelector(mapStateToProps(propertyId)),
		...mapDispatchToProps(useDispatch())
	};

	const bookingsLoading = useDataLoad(!props.bookings, () => props.getBookings(propertyId, state));
	const propertiesLoading = useDataLoad(!props.property, () => props.getPropertyData(propertyId));

	return (
		<PropertyBookingsList
			bookings={props.bookings}
			propertyId={propertyId}
			propertyName={(props.property || { name: '' }).name}
			loadingBookings={bookingsLoading || propertiesLoading}
			admin={props.admin}
			onUpdateQueryParams={(next) => {
				const nextState = { ...state, ...next };
				setState(nextState);
				props.getBookings(propertyId, nextState);
			}}
			currentQueryParams={state}
		/>
	);
};
